import {FormsModule, ReactiveFormsModule}  from '@angular/forms';
import {ApCoreModule}                      from '../ap-core/ap-core.module';
import {ApIconModule}                      from '../icons/ap-icon.module';
import {LayoutModule}                      from '@progress/kendo-angular-layout';
import {
  ButtonModule,
  SplitButtonModule
}                                          from '@progress/kendo-angular-buttons';
import {CommonModule}                      from '@angular/common';
import {InputsModule}                      from '@progress/kendo-angular-inputs';
import {
  ComboBoxModule,
  DropDownsModule
}                                          from '@progress/kendo-angular-dropdowns';
import {NgModule}                          from '@angular/core';
import {DateInputsModule}                  from '@progress/kendo-angular-dateinputs';
import {ApTranslationModule}               from '../translation/ap-translation.module';
import {ApNFertilizationRoutes}            from './ap-n-fertilization.routes';
import {
  BodyModule,
  ExcelModule,
  GridModule,
  GroupModule,
  HeaderModule,
  PagerModule,
  PDFModule,
  SharedModule
}                                          from '@progress/kendo-angular-grid';
import {PDFExportModule}                   from '@progress/kendo-angular-pdf-export';
import {ApNFertilizationOverviewComponent} from './components/ap-n-fertilization-overview.component';
import {ApUtilsModule}                     from '../ap-utils';
import {ApTooltipModule}                   from '../ap-tooltip/ap-tooltip.module';
import {ApResponsiveTextModule}            from '../ap-responsive-text/ap-responsive-text.module';
import {ApSectionHeaderModule}             from '../ap-section-header/ap-section-header.module';
import {ApNFertilizationLogfilesComponent} from './components/ap-n-fertilization-logfiles.component';
import {ApNFertilizationNNeedComponent}    from './components/ap-n-fertilization-n-need.component';
import {ApNFertilizationPlanningComponent} from './components/ap-n-fertilization-planning.component';
import {ApNFertilizationBookingComponent}  from './components/ap-n-fertilization-booking.component';
import {ApDynComponentModule}              from '../ap-dyncomponent/ap-dyncomponent.module';
import {ApFieldManagementModule}           from '../field-management/ap-field-management.module';


@NgModule({
  declarations: [
    ApNFertilizationOverviewComponent,
    ApNFertilizationLogfilesComponent,
    ApNFertilizationNNeedComponent,
    ApNFertilizationPlanningComponent,
    ApNFertilizationBookingComponent,
  ],
  exports: [
    ApNFertilizationOverviewComponent,
  ],
  imports: [
    ReactiveFormsModule,
    ApCoreModule,
    ApIconModule,
    LayoutModule,
    ButtonModule,
    CommonModule,
    SplitButtonModule,
    InputsModule,
    ComboBoxModule,
    DateInputsModule,
    DropDownsModule,
    FormsModule,
    GridModule,
    ExcelModule,
    PDFModule,
    PDFExportModule,
    ApTranslationModule,
    ApNFertilizationRoutes,
    ApUtilsModule,
    BodyModule,
    ApTooltipModule,
    PagerModule,
    ApResponsiveTextModule,
    SharedModule,
    HeaderModule,
    GroupModule,
    ApSectionHeaderModule,
    ApDynComponentModule,
    ApFieldManagementModule
  ],
  providers: [],
})
export class ApNFertilizationModule {
}
